<template>
	<el-dialog title="修改密码" :visible="visible" :close-on-click-modal="false" @close="close">
		<el-form ref="form" :model="form" :rules="rules" label-width="120px">

			<el-row>
				<el-col :span="12">
					<el-form-item label="当前密码" prop="passwordCurrent" required>
						<el-input v-model="form.passwordCurrent" show-password placeholder="请输入当前密码" />
					</el-form-item>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="12">
					<el-form-item label="新密码" prop="password" required>
						<el-input v-model="form.password" show-password placeholder="请输入新密码" />
					</el-form-item>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="12">
					<el-form-item label="确认密码" prop="passwordRepeat" required>
						<el-input v-model="form.passwordRepeat" show-password placeholder="请再输入一次新密码" />
					</el-form-item>
				</el-col>
			</el-row>

      <el-row>
        <el-col :span="20">
					<el-form-item>
						<el-button type="primary" @click="save">保存</el-button>
						<el-button @click="close">取消</el-button>
					</el-form-item>
        </el-col>
      </el-row>

		</el-form>
	</el-dialog>
</template>
<script>
import {updatePassword} from '@/api/hr/staff'
import form from '@/mixins/form'
export default {
	name: 'Password',
	mixins: [form],
	data() {
		return {
			form: {
				passwordCurrent: '',
				password: '',
				passwordRepeat: ''
			},
			api: {
				save: updatePassword
			}
		}
	}
}
</script>